import InvoiceFilters from "./InvoiceFilters";
import InvoiceTable from "./InvoiceTable";
import InvoicePagination from "./InvoicePagination";
import AnularInvoiceModal from "./modals/AnularInvoiceModal";
import InvalidacionModal from "./modals/InvalidacionModal";
import { useInvoices } from "../../hooks/useInvoices";
import { useInvoiceAnulacion } from "../../hooks/useInvoiceAnulacion";
import { useInvalidacion } from "../../hooks/useInvalidacion";
import { exportForAccountant } from "../../components/utils/invoiceExportAccountant";
import { validarRangoFechas } from "../../components/utils/invoiceValidation";
import Swal from "sweetalert2";
import "./Invoicelist.css";

export default function InvoiceList() {
  // Hook principal de facturas
  const {
    invoices,
    loading,
    fromDate,
    toDate,
    currentPage,
    totalPages,
    total,
    from,
    to,
    setFromDate,
    setToDate,
    fetchInvoices,
    handlePageChange,
    handleClearFilters
  } = useInvoices();

  // Hook de anulación
  const {
    showAnularModal,
    selectedInvoice: invoiceToAnular,
    motivoAnulacion,
    isAnulando,
    setMotivoAnulacion,
    handleOpenAnularModal,
    handleCloseAnularModal,
    handleAnularFactura
  } = useInvoiceAnulacion(() => fetchInvoices(currentPage));

  // Hook de invalidación
  const {
    showInvalidacionModal,
    selectedInvoice: invoiceToView,
    selectedInvalidacion,
    loadingInvalidacion,
    isDownloading,                      // ✅ AGREGADO
    handleVerInvalidacion,
    handleCloseInvalidacionModal,
    handleDescargarInvalidacion         // ✅ AGREGADO
  } = useInvalidacion();

  /**
   * Maneja la búsqueda con validación de fechas
   */
  const handleSearch = () => {
    const validacion = validarRangoFechas(fromDate, toDate);
    
    if (!validacion.valido) {
      return Swal.fire("Atención", validacion.mensaje, "warning");
    }

    fetchInvoices(1);
  };

  /**
   * Maneja la exportación para el contador
   */
  const handleExportForAccountant = async () => {
    await exportForAccountant(fromDate, toDate);
  };

  return (
    <div className="invoice-list-container">
      <div className="card">
        {/* Header */}
        <div className="card-header">
          <h2 className="card-title">📄 Facturas (DTE)</h2>
          
          <button 
            className="btn btn-primary"
            onClick={handleExportForAccountant}
            disabled={!fromDate || !toDate}
            title="Exporta formato específico para el contador (2 hojas separadas)"
          >
            📋 Descargar archivo excel
          </button>
        </div>

        <div className="card-body">
          {/* Filtros */}
          <InvoiceFilters
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            onSearch={handleSearch}
            onClear={handleClearFilters}
          />

          {/* Información de resultados */}
          <div className="results-info">
            <p>
              Mostrando <strong>{from} - {to}</strong> de <strong>{total}</strong> facturas
            </p>
          </div>

          {/* Tabla */}
          <InvoiceTable
            invoices={invoices}
            loading={loading}
            onAnular={handleOpenAnularModal}
            onVerInvalidacion={handleVerInvalidacion}
            onClearFilters={handleClearFilters}
            hasFilters={!!(fromDate || toDate)}
          />

          {/* Paginación */}
          {!loading && (
            <InvoicePagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>

      {/* Modal de Anulación */}
      <AnularInvoiceModal
        show={showAnularModal}
        invoice={invoiceToAnular}
        motivo={motivoAnulacion}
        isAnulando={isAnulando}
        onMotivoChange={setMotivoAnulacion}
        onAnular={handleAnularFactura}
        onClose={handleCloseAnularModal}
      />

      {/* Modal de Invalidación */}
      <InvalidacionModal
        show={showInvalidacionModal}
        invoice={invoiceToView}
        invalidacion={selectedInvalidacion}
        loading={loadingInvalidacion}
        onDescargar={handleDescargarInvalidacion}  // ✅ AGREGADO
        isDownloading={isDownloading}              // ✅ AGREGADO
        onClose={handleCloseInvalidacionModal}
      />
    </div>
  );
}